import { USER_STORAGE_KEY } from '../../admin/auth/CurrentUserContext';

function isProfileComplete(userProfile) {
  return !!(
    userProfile.given_name &&
    userProfile.family_name &&
    userProfile.email &&
    userProfile.company &&
    userProfile.phone
  );
}

function readAdminFromLocalStorage() {
  try {
    const stored = window.localStorage.getItem(USER_STORAGE_KEY);
    return stored ? JSON.parse(stored) : null;
  } catch {
    return null;
  }
}

export function seedProfileFromAdmin(userProfile, updateUserProfile) {
  if (isProfileComplete(userProfile)) return;

  const admin = readAdminFromLocalStorage();
  if (!admin) return;

  const updates = {};
  if (!userProfile.given_name && admin.given_name) updates.given_name = admin.given_name;
  if (!userProfile.family_name && admin.family_name) updates.family_name = admin.family_name;
  if (!userProfile.email && admin.email) updates.email = admin.email;
  if (!userProfile.company && admin.organization_name) updates.company = admin.organization_name;

  if (Object.keys(updates).length) updateUserProfile(updates);
}
